module.exports = __webpack_public_path__ + "static/media/FirstLight.636ea2c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/FirstLight.jpg
// module id = 205
// module chunks = 0